













import { Component, Vue } from 'vue-property-decorator'
import { RouteConfig } from 'vue-router'

@Component
export default class CommissionModule extends Vue {
  get sections (): Array<RouteConfig> {
    const base = '/commission-module'
    return [
      {
        path: `${base}/transactions`,
        name: 'Transactions'
      },
      {
        path: `${base}/other-income-deduction`,
        name: 'Other Income and Deduction'
      },
      {
        path: `${base}/vestings`,
        name: 'Vestings'
      },
      {
        path: `${base}/introducers`,
        name: 'Introducers'
      },
      {
        path: `${base}/servicing-agents`,
        name: 'Servicing Agents'
      },
      {
        path: `${base}/reports`,
        name: 'Reports'
      },
      {
        path: `${base}/commission-statements`,
        name: 'Commission Statements'
      }
    ]
  }
}
